import apiClient from '@/utils/apiClient';

const CELLO_SIGNUP_EVENT_PATH = '/api/v2/cello/send-signup-event';

export const sendCelloSignupEvent = async (payload: {
	userId: string;
	celloReferral: string;
	userData: {
		emailAddress: string;
		businessName: string;
	};
}): Promise<{
	success: boolean;
	message?: string;
	data?: any;
}> => {
	const response = await apiClient.request({
		method: 'POST',
		endPoint: CELLO_SIGNUP_EVENT_PATH,
		body: payload,
	});

	return response;
};
